/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Box } from '@mui/material';
import { generateShortId } from '@utils';

import FileItem from './FileItem';
import styles from './fileList.style';

const FileList = ({
  files,
  onDeleteFile,
  onClickFile,
  onEditFile,
  enablePreviewFile,
  showMenuItem = true,
}) => {
  if (!files.length) {
    return null;
  }

  return (
    <Box sx={styles.filesListWrapper}>
      {files?.map?.((file) => {
        return (
          <FileItem
            key={generateShortId()}
            enablePreviewFile={enablePreviewFile}
            file={file}
            files={files}
            showMenuItem={showMenuItem}
            onClick={onClickFile}
            onDelete={onDeleteFile}
            onEdit={onEditFile}
          />
        );
      })}
    </Box>
  );
};

export default FileList;
